import * as React from "react";
import { forwardRef } from "react";
const SvgCloseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M25.75 5.40039L5.75 25.4004M25.75 25.4004L5.75 5.40039L25.75 25.4004Z", stroke: "white", strokeWidth: 3, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCloseIcon);
export { ForwardRef as ReactComponent };
